<template>
  <div class="goods-editor">
    <div class="goods-editor-inner">
      <div class="tip">带“*”号为必填项</div>
      <FormList
        :list="formData.taxPre === 0 ? taxFormList : formList"
        :data="formData"
        :onChange="onInputChange"
      >
        <div slot="revenueCode" >
          <van-button type="info" @click="handleClick('intelligentCode')">智能赋码</van-button>
        </div>
      </FormList>
      <van-popup v-model="showRevenuePicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="taxCodeList.map(v => `${v.shortName}-${v.revenueCode}`)"
          @cancel="showRevenuePicker = false"
          @confirm="onConfirm"
        />
      </van-popup>
    </div>
    <van-row class='btn-wrap'>
      <van-button @click="saveGoods" class="confirm-btn" type="info" color="#4573DE">确 认</van-button>
    </van-row>
  </div>
</template>

<script>
import {
  Button,
  Row,
  Notify,
  Popup,
  Picker,
  Toast
} from 'vant'
import FormList from '@components/FormList'
import { invoiceRequest } from '@services'
import { getMixLength, renderTextWithConfig, getQuery, isEmpty } from '@utils/basicUtil'
import {
  // TAX_RATE,
  TAX_PRE,
  TAX_SIGN,
  // TAX_PRE_TYPE,
  getTaxSpecialType
} from '@assets/config'

export default {
  data () {
    return {
      formData: {
        taxSign: 1,
        taxPre: 1,
        taxPreType: ''
      },
      total: 0,
      taxSpecialTypeList: getTaxSpecialType(),
      taxCodeList: [],
      showRevenuePicker: false,
      taxRateConfig: [{ value: 0, title: '0%' }, { value: 0.01, title: '1%' }, { value: 0.015, title: '1.5%' }, { value: 0.03, title: '3%' }, { value: 0.05, title: '5%' }],
      taxPreTypeConfig: [{ value: 0, title: '普通零税率' }],
      taxHeadcountTax: ''
    }
  },
  computed: {
    formList () {
      return [
        {
          type: 'text',
          field: 'goodsCode',
          label: '商品编码',
          required: true,
          placeholder: '请输入商品编码'
        },
        {
          type: 'text',
          field: 'goodsName',
          label: '商品名称',
          required: true,
          placeholder: '请输入商品名称'
        },
        {
          type: 'text',
          field: 'specification',
          label: '规格型号',
          placeholder: '请输入规格型号'
        },
        {
          type: 'text',
          field: 'unit',
          label: '单位',
          placeholder: '请输入单位'
        },
        {
          type: 'number',
          field: 'price',
          label: '单价',
          placeholder: '请输入商品单价'
        },
        // 0:'不含税',
        // 1:'含税'
        {
          type: 'select',
          field: 'taxSign',
          label: '含税标识',
          placeholder: '请选择含税标识',
          options: TAX_SIGN,
          render: (text) => renderTextWithConfig(text, TAX_SIGN)
        },
        {
          type: 'text',
          field: 'revenueCode',
          label: '税收分类编码',
          required: true,
          placeholder: '请输入税收分类编码',
          slot: 'revenueCode'
        },
        {
          type: 'text',
          field: 'shortName',
          label: '税编简称',
          readonly: true,
          placeholder: '自动带出'
        },
        {
          type: 'select',
          field: 'taxPre',
          label: '享受优惠政策',
          required: true,
          placeholder: '请选择享受优惠政策',
          options: TAX_PRE,
          render: (text) => renderTextWithConfig(text, TAX_PRE)
        },
        {
          type: 'select',
          field: 'taxSpecialType',
          label: '优惠政策类型',
          disabled: true,
          placeholder: '',
          options: this.taxSpecialTypeList,
          render: (text) => renderTextWithConfig(text, this.taxSpecialTypeList)
        },
        {
          type: 'select',
          field: 'taxRate',
          label: '税率',
          required: true,
          placeholder: '请选择商品税率',
          options: this.taxRateConfig,
          render: (text) => renderTextWithConfig(text, this.taxRateConfig)
        },
        {
          type: 'select',
          field: 'taxPreType',
          label: '免税类型',
          placeholder: '请选择免税类型',
          options: this.taxPreTypeConfig,
          render: (text) => renderTextWithConfig(text, this.taxPreTypeConfig)
        }
      ]
    },
    taxFormList () {
      return [
        {
          type: 'text',
          field: 'goodsCode',
          label: '商品编码',
          required: true,
          placeholder: '请输入商品编码'
        },
        {
          type: 'text',
          field: 'goodsName',
          label: '商品名称',
          required: true,
          placeholder: '请输入商品名称'
        },
        {
          type: 'text',
          field: 'specification',
          label: '规格型号',
          placeholder: '请输入规格型号'
        },
        {
          type: 'text',
          field: 'unit',
          label: '单位',
          placeholder: '请输入单位'
        },
        {
          type: 'number',
          field: 'price',
          label: '单价',
          placeholder: '请输入商品单价'
        },
        // 0:'不含税',
        // 1:'含税'
        {
          type: 'select',
          field: 'taxSign',
          label: '含税标识',
          placeholder: '请选择含税标识',
          options: TAX_SIGN,
          render: (text) => renderTextWithConfig(text, TAX_SIGN)
        },
        {
          type: 'text',
          field: 'revenueCode',
          label: '税收分类编码',
          required: true,
          placeholder: '请输入税收分类编码',
          slot: 'revenueCode'
        },
        {
          type: 'text',
          field: 'shortName',
          label: '税编简称',
          readonly: true,
          placeholder: '自动带出'
        },
        {
          type: 'select',
          field: 'taxPre',
          label: '享受优惠政策',
          required: true,
          placeholder: '请选择享受优惠政策',
          options: TAX_PRE,
          render: (text) => renderTextWithConfig(text, TAX_PRE)
        },
        {
          type: 'select',
          field: 'taxSpecialType',
          label: '优惠政策类型',
          placeholder: '请选择优惠政策类型',
          options: this.taxSpecialTypeList,
          render: (text) => renderTextWithConfig(text, this.taxSpecialTypeList)
        },
        {
          type: 'select',
          field: 'taxRate',
          label: '税率',
          required: true,
          placeholder: '请选择商品税率',
          options: this.taxRateConfig,
          render: (text) => renderTextWithConfig(text, this.taxRateConfig)
        },
        {
          type: 'select',
          field: 'taxPreType',
          label: '免税类型',
          placeholder: '请选择免税类型',
          options: this.taxPreTypeConfig,
          render: (text) => renderTextWithConfig(text, this.taxPreTypeConfig)
        }
      ]
    }
  },
  mounted () {
    const { id } = getQuery()
    if (id) {
      this.getGoodsDetail(id)
    } else {
      this.getGoodsCode()
    }
  },
  methods: {
    async getGoodsDetail (id) {
      const result = await invoiceRequest.goods.getGoodsInfo({}, { id })
      if (result.success) {
        this.formData = result.result
        this.taxHeadcountTax = result.result.taxRate
      }
      this.autoChange(this.formData.taxSpecialType, this.formData.taxRate)
    },
    saveGoods () {
      const postData = {
        ...this.formData
      }
      this.addGoods(postData)
    },
    async intelligentCode () {
      const { goodsName } = this.formData
      if (goodsName === undefined || goodsName.trim().length === 0) {
        return Notify({ type: 'danger', message: '请输入商品名称!' })
      }
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '智能匹配税收分类编码中！'
      })
      const result = await invoiceRequest.goods.getRevenueCodeByGoodsName({ title: goodsName })
      if (result.result && Array.isArray(result.result)) {
        const { details, name } = result.result[0]
        if (details.length === 1) {
          const { taxRate, revenueCode, shortName } = details[0]
          this.formData = {
            ...this.formData,
            revenueCode: revenueCode,
            revenueName: name,
            shortName: shortName,
            taxRate: taxRate
          }
        } else {
          const taxCodeList = details.map((v, i) => ({
            revenueName: v.parentName,
            shortName: v.shortName,
            revenueCode: v.revenueCode,
            taxRate: v.taxRate,
            order: i + 1
          }))
          this.taxCodeList = taxCodeList
          this.showRevenuePicker = true
        }
      } else {

      }
      Toast.clear()
    },
    onConfirm (value) {
      console.log(value)
      if (value) {
        const arr = value.split('-')
        const shortName = arr[0]
        const revenueCode = arr[1]
        let record = {}
        this.taxCodeList.forEach(v => {
          if (v.shortName === shortName && v.revenueCode === revenueCode) {
            record = { ...v }
          }
        })
        this.formData = {
          ...this.formData,
          revenueName: record.revenueName,
          shortName: record.shortName,
          revenueCode: record.revenueCode,
          taxRate: Number(record.taxRate)
        }
      }
      this.showRevenuePicker = false
    },
    handleClick (type) {
      if (type === 'intelligentCode') {
        this.intelligentCode()
      }
    },
    onInputChange ({ e, field }) {
      if (field === 'taxPre') {
        if (e === 0) {
          this.autoChange(this.formData.taxSpecialType, this.formData.taxRate)
        } else {
          this.onInputChange({ e: '', field: 'taxRate' })
          this.onInputChange({ e: '', field: 'taxSpecialType' })
        }
      }
      if (field === 'taxSpecialType') {
        this.autoChange(e, this.formData.taxRate)
      }
      if (field === 'taxRate') {
        console.log(e)
        this.autoChange(this.formData.taxSpecialType, e)
      }
      this.formData = {
        ...this.formData,
        [field]: e
      }
    },
    async addGoods (postData) {
      if (postData.goodsName === undefined || postData.goodsName.trim().length === 0) {
        return Notify({ type: 'danger', message: '请输入商品名称!' })
      }
      if (getMixLength(postData.goodsName) > 72) {
        return Notify({ type: 'danger', message: '货物及服务名称不能大于36个汉字或72个字符!' })
      }
      if (isEmpty(postData.revenueCode)) {
        return Notify({ type: 'danger', message: '请输入税收分类编码!' })
      }
      if (
        postData.taxRate === undefined || postData.taxRate === null
      ) {
        return Notify({ type: 'danger', message: '请选择商品税率!' })
      }
      const { id } = getQuery()
      let url = invoiceRequest.goods.addGoods
      if (id) {
        url = invoiceRequest.goods.editGoods
      }
      const data = await url(postData)
      if (data.success) {
        this.$router.replace('/user-center/goodsList')
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async getGoodsCode () {
      const result = await invoiceRequest.goods.getGoodsCode({ type: 0 })
      if (result.success) {
        this.onInputChange({ field: 'goodsCode', e: result.result })
      }
      this.autoChange('', 0)
    },
    autoChange (taxSpecialType, taxRate) {
      let taxRateConfig = this.taxRateConfig
      let taxPreTypeConfig = this.taxPreTypeConfig
      // taxRate
      console.log(taxSpecialType, taxRate)
      if (taxSpecialType === '03') { // 免税
        taxRateConfig = [{ value: 0, title: '0%' }]
        taxPreTypeConfig = [{ value: 1, title: '免税' }]
      } else if (taxSpecialType === '04') { // 不征税
        taxRateConfig = [{ value: 0, title: '0%' }]
        taxPreTypeConfig = [{ value: 2, title: '不征税' }]
      } else if (['02', '05', '06', '07', '11', '12', '13', '14', '15', '16', '17', '18'].includes(taxSpecialType)) {
        taxRateConfig = this.taxHeadcountTax ? [{ value: 0, title: '0%' }, { value: 0.03, title: '3%' }, { value: Number(this.taxHeadcountTax), title: Number(this.taxHeadcountTax) * 100 + '%' }] : [{ value: 0, title: '0%' }, { value: 0.03, title: '3%' }]
        taxPreTypeConfig = taxRate === 0 ? [{ value: 0, title: '普通零税率' }, { value: 1, title: '免税' }, { value: 2, title: '不征税' }] : [{ value: 0, title: '正常税率' }]
      } else if (taxSpecialType === '01') {
        if (this.taxHeadcountTax) {
          taxRateConfig = [{ value: 0, title: '0%' }, { value: 0.03, title: '3%' }, { value: 0.05, title: '5%' }, { value: Number(this.taxHeadcountTax), title: Number(this.taxHeadcountTax) * 100 + '%' }]
        } else {
          taxRateConfig = [{ value: 0, title: '0%' }, { value: 0.03, title: '3%' }, { value: 0.05, title: '5%' }]
        }
        taxPreTypeConfig = taxRate === 0 ? [{ value: 0, title: '普通零税率' }, { value: 1, title: '免税' }, { value: 2, title: '不征税' }] : [{ value: 0, title: '正常税率' }]
      } else if (['08'].includes(taxSpecialType)) {
        taxRateConfig = this.taxHeadcountTax ? [{ value: 0, title: '0%' }, { value: 0.03, title: '3%' }, { value: Number(this.taxHeadcountTax), title: Number(this.taxHeadcountTax) * 100 + '%' }] : [{ value: 0, title: '0%' }, { value: 0.03, title: '3%' }]
        taxPreTypeConfig = taxRate === 0 ? [{ value: 0, title: '普通零税率' }, { value: 1, title: '免税' }, { value: 2, title: '不征税' }] : [{ value: 0, title: '正常税率' }]
      } else if (['09'].includes(taxSpecialType)) {
        taxRateConfig = this.taxHeadcountTax ? [{ value: 0, title: '0%' }, { value: 0.03, title: '3%' }, { value: 0.05, title: '5%' }, { value: Number(this.taxHeadcountTax), title: Number(this.taxHeadcountTax) * 100 + '%' }] : [{ value: 0, title: '0%' }, { value: 0.03, title: '3%' }, { value: 0.05, title: '5%' }]
        taxPreTypeConfig = taxRate === 0 ? [{ value: 0, title: '普通零税率' }, { value: 1, title: '免税' }, { value: 2, title: '不征税' }] : [{ value: 0, title: '正常税率' }]
      } else if (['10'].includes(taxSpecialType)) {
        taxRateConfig = [{ value: 0.015, title: '1.5%' }]
        taxPreTypeConfig = [{ value: 0, title: '正常税率' }]
      } else if (!taxSpecialType) {
        taxRateConfig = [{ value: 0, title: '0%' }, { value: 0.01, title: '1%' }, { value: 0.015, title: '1.5%' }, { value: 0.03, title: '3%' }, { value: 0.05, title: '5%' }, { value: 0.09, title: '9%' }, { value: 0.13, title: '13%' }]
        taxPreTypeConfig = taxRate === 0 ? [{ value: 0, title: '普通零税率' }, { value: 1, title: '免税' }, { value: 2, title: '不征税' }] : [{ value: 0, title: '正常税率' }]
      }
      const map = new Map()
      taxRateConfig.forEach(i => map.set(i.title, i))
      this.taxRateConfig = taxRateConfig = Array.from(map.values())
      this.taxPreTypeConfig = taxPreTypeConfig
    }
  },
  components: {
    FormList,
    [Button.name]: Button,
    [Row.name]: Row,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Toast.name]: Toast

  }
}
</script>

<style lang="less" scoped src="./style.less"/>
